import { InjectionToken } from '@angular/core';

/**
 * Whether this app's auth interceptor should attach its bearer token to provider-index requests.
 *
 * Off unless an app opts in. provider-index is anonymous apart from its race/ethnicity filter and
 * facet, which require an admin token, so only the admin portal has a reason to send one — and only a
 * coordinator's token is an admin's. Left on for every app, the shared interceptor would attach a
 * client's or a provider's token to ordinary public directory searches, widening where that
 * credential can be logged or leaked to reach an endpoint that would refuse it anyway.
 *
 * An app-level opt-in rather than a per-URL rule because the interceptor is registered per app
 * (`AuthLoaderModule.forRoot`) and the question is "may this app's token go here?", which the app
 * knows statically.
 */
export const PROVIDER_INDEX_AUTHENTICATED = new InjectionToken<boolean>(
  'PROVIDER_INDEX_AUTHENTICATED',
  { providedIn: 'root', factory: () => false }
);
